import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import {ProductType, useAppData} from "../../context/Contexts";
import {useEffect, useState} from "react";
import {
    formatMoney,
    getCurrency,
    getOfferPrice,
    isBundle,
    isFront,
    isRear,
    getPriceElemById, getNewPartNumber,
} from "../../helpers/helpers";
import StatusBar from "../StatusBar";
import Step1 from "../Step1";
import MainStep from "../MainStep";
import StepNoCompatible from "../StepNoCompatible";
import {set} from "react-hook-form";
//import { useWhatChanged } from '@simbathesailor/use-what-changed';

declare global {
    interface Window {
        is_real_truck?: boolean;
        scs_custom_endpoint?: boolean;
        scs_custom_endpoint_url?: string;
        scs_show_new_year_promo_section?: boolean;
        scs_show_str_section?: boolean;
        scs_show_bf_section?: boolean;
        scs_show_earlybf_section?: boolean;
        scs_bonus_discount?: string;
        scs_bonus_product?: string;
        scs_custom_style?: string;
        scs_extra_media?: object;
        scs_use_alternate_images?: boolean;
        is_embedded?: boolean;
        scs_step_1_bottom_text?: string;
        scs_step_2_bottom_text?: string;
        scs_widget_id?: string;
        scs_use_optgroup?: boolean;
        scs_force_custom?: boolean;
        scs_force_normal?: boolean;
        scs_page_seo?: boolean;
        scs_show_bonus_section?: boolean;
        scs_show_timer?: boolean;
        scs_countdown_timer?: string;
        scs_use_custom_title?: boolean;
        scs_show_color_alert?: boolean;
        scs_product_alert_text?: string;
        scs_alert_colors?: string[];
        scs_bulk_alert_colors?: string[];
        scs_has_double_offer?: boolean;
        scs_blocks?: string[];
        Shopify?: any;
        scs_ultimate_upgrade?: boolean;
        scs_hide_timer?: boolean;
        scs_hide_bonus_3_section?: boolean;
        scs_black_friday_2025?: boolean;
        scs_black_friday_2025_h1?: string;
        scs_black_friday_2025_h2?: string;
        scs_title_show_timer?:boolean;

        scs_promo_bonus_sale_price_1?:string;
        scs_promo_bonus_sale_price_2?:string;
        scs_promo_bonus_sale_price_3?:string;
        scs_promo_bonus_compare_price_1?:string;
        scs_promo_bonus_compare_price_2?:string;
        scs_promo_bonus_compare_price_3?:string;

        scs_promo_bonus_1_price?:number;
        scs_promo_bonus_1_alt?:string;
        scs_promo_bonus_1_img?:string;
        scs_promo_bonus_1_title?:string;

        scs_promo_bonus_2_price?:number;
        scs_promo_bonus_2_alt?:string;
        scs_promo_bonus_2_img?:string;
        scs_promo_bonus_2_title?:string;

        scs_promo_bonus_3_price?:number;
        scs_promo_bonus_3_alt?:string;
        scs_promo_bonus_3_img?:string;
        scs_promo_bonus_3_title?:string;

        scs_promo_bonus_4_price?:number;
        scs_promo_bonus_4_alt?:string;
        scs_promo_bonus_4_img?:string;
        scs_promo_bonus_4_title?:string;

        scs_promo_extra_images_filter?:string;
        scs_promo_special_text?:string;

    }
}

interface CustomScsParams {
    _scs_utm_medium?: string;
    _scs_utm_campaign?: string;
    _scs_utm_source?: string;
    _scs_attribution?: string;
    _trim?: string;
    _cab_size?: string;
    Trim?: string;
}

interface ScsProperties {
    _source?: string;
    _seat?: string;
    _color?: string;
    _bonus?: string;
    _bonus_type?: string;
    _widget_id?: string;
    _your_vehicle?: string;
    "Your Vehicle"?: string;
    Trim?: string;
    _trim?: string;
    _cab_size?: string;
    _gid?: string;
}

async function getCustomSku(
    input: {
        step?: number | undefined;
        seat?: string | undefined;
        color?: string | undefined;
        selectedId?: string | undefined;
        year?: number | undefined;
        make?: string | undefined;
        model?: string | undefined;
        check?:
            | {
            compatibility: string;
            compatibility_custom: string;
            availability: object;
        }
            | undefined;
        product?: ProductType | undefined;
        originalProduct?: ProductType | undefined;
        addons?: string | undefined;
        trim?: string | undefined;
        has_trims?: boolean | undefined;
        with_bonus?: boolean | undefined;
    },
    sku,
) {
    const requestOptions: RequestInit = {
        method: "GET",
        redirect: "follow",
    };

    const resp = await fetch(
        `https://scsbiz.wearevisum.com/api/v1/sku?` +
        `year=${encodeURIComponent(input.year ?? "")}` +
        `&make=${encodeURIComponent(input.make ?? "")}` +
        `&model=${encodeURIComponent(input.model ?? "")}` +
        `&type=${encodeURIComponent(input.seat ?? "")}` +
        `&color=${encodeURIComponent(input.color ?? "")}`,
        requestOptions,
    );

    const data = await resp.json();

    return data.data;
}

function getNewSku(currentAppData) {
    if (currentAppData && currentAppData?.check) {
        if (
            currentAppData?.check.availability &&
            currentAppData?.check.availability[currentAppData?.seat] &&
            currentAppData?.check.availability[currentAppData?.seat]["new_sku"] &&
            currentAppData?.check.availability[currentAppData?.seat]["new_sku"][currentAppData?.color]
        ) {
            return currentAppData?.check.availability[currentAppData?.seat]["new_sku"][currentAppData?.color];
        }
    }

    return "";
}

function getSeatCoverId(currentAppData) {
    if (currentAppData && currentAppData?.check) {
        if (
            currentAppData?.check.availability &&
            currentAppData?.check.availability[currentAppData?.seat] &&
            currentAppData?.check.availability[currentAppData?.seat]["prekit"] &&
            currentAppData?.check.availability[currentAppData?.seat]["prekit"][
                currentAppData?.color
                ]
        ) {
            return currentAppData?.check.availability[currentAppData?.seat]["prekit"][
                currentAppData?.color
                ]["id"];
        }
    }

    return currentAppData?.selectedId;
}


export default function StepNav(props) {
    const {currentAppData, setCurrentAppData} = useAppData();

    const [disabled, setDisabled] = useState(true);

    const [product, setProduct] = useState({});

    const [loading, setLoading] = useState(false);

    const [options, setOptions] = useState([]);
    const [price, setPrice] = useState("");
    const [comparePrice, setComparePrice] = useState("");
    const [savings, setSavings] = useState<undefined | string>(undefined);
    const [partNumber, setPartNumber] = useState('');

    function getGid() {
        const id = window.crypto.randomUUID();
        return id;
    }

    function getSeatId() {
        const colorSelected = currentAppData?.color;
        if (colorSelected === undefined) {
            return "46996385366308";
        }
        const colorMapping = {
            Black: "46996385366308",
            "Black & Grey": "47575557144868",
            Beige: "46996385333540",
            "Wine Red": "49936887021860",
            "Black & Red": "49936887120164",
            "Black & Blue": "49936887087396",
            "Black & White": "49936887054628",
            "Black & Pink": "46996385366308",
            Tan: "46996385366308",
        };

        if (!colorMapping.hasOwnProperty(colorSelected)) {
            return "46996385366308";
        }

        return colorMapping[colorSelected];
    }

    useEffect(() => {
        const product1 = currentAppData?.product;
        if (product1 && product1.options) {
            setProduct(product1);
        }
    }, [currentAppData?.product]);

    useEffect(() => {
        console.log("product", product);
        const filtered = getPriceElemById(product.variants, currentAppData?.selectedId);
            
        if (filtered.length > 0) {
            const currency = getCurrency(filtered[0].node.priceV2.currencyCode);
            setPrice(
                currency + "" + parseFloat(filtered[0].node.priceV2.amount).toFixed(0),
            );

            if (filtered[0].node.compareAtPrice) {
                setComparePrice(
                    currency +
                    "" +
                    parseFloat(filtered[0].node.compareAtPrice.amount).toFixed(0),
                );
                setSavings(
                    currency +
                    "" +
                    formatMoney(
                        filtered[0].node.compareAtPrice.amount -
                        getOfferPrice(filtered[0].node.priceV2.amount),
                    ),
                );
            } else {
                setComparePrice("");
                if (window.scs_show_earlybf_section) {
                    setSavings(currency + "" + formatMoney(20));
                } else {
                    setSavings(undefined);
                }
            }
        } else {
            setSavings(undefined);
        }



    }, [currentAppData?.selectedId]);

    useEffect(() => {
        setPartNumber(getNewPartNumber(currentAppData));
    }, [currentAppData?.check, currentAppData?.selectedId])

    // const handleBack = () => {
    //     setCurrentAppData(prevState => {
    //         return {...prevState, step: prevState.step - 1}
    //     });
    function setDoubleOffer() {
        console.log('test', window.scs_has_double_offer);
        if (window.scs_has_double_offer !== true) {
            return;
        }
        if (currentAppData?.show_upsell !== true) {
            setCurrentAppData(prevState => {
                return {...prevState, show_upsell: true, show_offer: false}
            })

        } else {

            setCurrentAppData((prevState) => {
                return {
                    ...prevState,
                    show_upsell: false,
                    show_offer: false,
                    year: '',
                    make: '',
                    model: '',
                    step: 1
                };
            });
        }
    }

    // }
    const handleNext = async () => {
        let element1;
        if (currentAppData?.step === 3) {
            setLoading(true);
            // console.log(`add to cart\nVehicle: ${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}` +
            //     `\nSeat: ${currentAppData?.seat}` +
            //     `\nColor: ${currentAppData?.color}` +
            //     `\nID: ${currentAppData?.selectedId}` +
            //     `\nAddons: ${currentAppData?.addons || ''}`);

            if (
                window.is_real_truck === true ||
                window.scs_custom_endpoint === true
            ) {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                console.log("selectedId", currentAppData?.selectedId);
                const filteredVariants = currentAppData.product?.variants?.edges.filter(
                    (variant) => {
                        return (
                            variant.node.id.replace("gid://shopify/ProductVariant/", "") ==
                            currentAppData?.selectedId
                        );
                    },
                );
                console.log(
                    "filteredVariants",
                    currentAppData.product,
                    filteredVariants,
                );

                if (!filteredVariants || filteredVariants.length == 0) {
                    alert("No matches");
                    return;
                }
                const selectedVariant = filteredVariants[0];

                const raw = JSON.stringify([
                    {
                        sku: selectedVariant.node.sku,
                        name:
                            currentAppData?.product?.title +
                            " - " +
                            selectedVariant.node.title,
                        fitment: `${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}`,
                        qty: "1",
                    },
                ]);

                let custom_url = "";
                if (window.is_real_truck) {
                    custom_url =
                        "https://realtruck.com/checkout/cart/?3rdParty=seatcoversolutions";
                }
                if (window.scs_custom_endpoint) {
                    custom_url = window.scs_custom_endpoint_url || "";
                }

                if (!custom_url || custom_url === "") {
                    console.error("No matches");
                    return;
                }

                var form = document.createElement("form");
                form.method = "POST";
                form.target = "_parent";
                form.action = custom_url;

                if (window.is_real_truck) {
                    element1 = document.createElement("input");
                    element1.value = raw;
                    element1.name = "body";
                    form.appendChild(element1);
                }
                if (window.scs_custom_endpoint) {
                    element1 = document.createElement("input");
                    element1.value = "SC";
                    element1.name = "LineCode";
                    form.appendChild(element1);

                    const element2 = document.createElement("input");
                    element2.value = await getCustomSku(
                        currentAppData,
                        selectedVariant.node.sku,
                    );
                    element2.name = "PartNumber";
                    form.appendChild(element2);

                    const element3 = document.createElement("input");
                    element3.value = "1";
                    element3.name = "Quantity";
                    form.appendChild(element3);

                    const element4 = document.createElement("input");
                    element4.value =
                        currentAppData?.product?.title + " - " + selectedVariant.node.title;
                    element4.name = "Name";
                    form.appendChild(element4);

                    const element5 = document.createElement("input");
                    element5.value = `${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}`;
                    element5.name = "Fitment";
                    form.appendChild(element5);

                    const queryParameters = new URLSearchParams(window.location.search);
                    const SessionId = queryParameters.get("SessionId") ?? "";
                    const element6 = document.createElement("input");
                    element6.value = SessionId;
                    element6.name = "SessionId";
                    form.appendChild(element6);
                }

                document.body.appendChild(form);

                document.body.appendChild(form);

                form.submit();

                return;
            }

            let has3Bonus = false;
            if (isBundle(currentAppData)) {
                has3Bonus = true;
            } else if (isFront(currentAppData)) {
                has3Bonus = true;
            } else if (isRear(currentAppData)) {
                has3Bonus = true;
            }

            const gid = getGid();
            const items: any[] = [];

            const props1 = {
                _gid: gid,
                _new_sku: getNewSku(currentAppData),
                _seat: currentAppData.seat,
                _color: currentAppData.color,
                "Your Vehicle":
                    `${currentAppData.year} ${currentAppData.make} ${currentAppData.model}`.trim(),
                _your_vehicle:
                    `${currentAppData.year} ${currentAppData.make} ${currentAppData.model}`.trim(),

            };
            const partNumber = getNewPartNumber(currentAppData);
            if (partNumber) {
                props1['Part #'] = partNumber;
                props1['_part_no'] = partNumber;
            }
            if (window.scs_black_friday_2025) {
                props1['_widget_id'] = window.scs_promo_main_widget_id;//'5090101';
            }
            const obj1 = {
                quantity: 1,
                id: getSeatCoverId(currentAppData),
                
                properties: getProperties(props1),
            };
            if (currentAppData.show_offer && currentAppData.show_upsell) {
                obj1.properties["_widget_id"] = '5090100';
                window.Shopify.analytics.publish("show_upsell_redemption", {
                    campaign_id: 'double_offer',
                    vehicle:
                        `${currentAppData.year} ${currentAppData.make} ${currentAppData.model}`.trim(),
                    year: currentAppData.year,
                    make: currentAppData.make,
                    model: currentAppData.model,
                    trim: currentAppData.trim,
                    cab: currentAppData.cab,
                    seat: currentAppData.seat,
                    color: currentAppData.color,
                });
            }
            if (has3Bonus) {
                obj1.properties["_has_bonus"] = has3Bonus;
            }
            items.push(obj1);


            let cc = "STR09FR";
            if (window.scs_black_friday_2025 === true || (window.scs_ultimate_upgrade === true && currentAppData?.ultimate_upgrade === true)) {
                const widget_id = window.scs_widget_id
                    ? window.scs_widget_id
                    : "4100206";

                let _bonus = "";
                if ((window.scs_ultimate_upgrade === true && currentAppData?.ultimate_upgrade === true)) {
                    _bonus = "ultimate-offer";
                }
                if (window.scs_black_friday_2025) {
                    _bonus = "bf2025";
                }

                if (window.scs_bonus_product) {
                    window.scs_bonus_product.split(",").map((id) => {
                        if (id === 'WHEEL_COVER') {
                            const obj2 = {
                                quantity: 1,
                                id: getSeatId(),
                                discount_code: cc,
                                properties: getProperties({
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: _bonus,
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }),
                            };
                            items.push(obj2);
                        } else {
                            items.push(
                                getItemObj(id, currentAppData, {
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: _bonus,
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }),
                            );
                        }
                    });
                }
            } else if (window.scs_show_new_year_promo_section) {
                const widget_id = window.scs_widget_id
                    ? window.scs_widget_id
                    : "4100206";

                // console.log("add for scs_show_new_year_promo_section");
                cc = window.scs_bonus_discount || "";

                if (window.scs_bonus_product) {
                    window.scs_bonus_product.split(",").map((id) => {
                        if (id === 'WHEEL_COVER') {
                            const obj2 = {
                                quantity: 1,
                                id: getSeatId(),
                                discount_code: cc,
                                properties: getProperties({
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: "current-offer",
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }),
                            };
                            items.push(obj2);
                        } else {
                            items.push(
                                getItemObj(id, currentAppData, {
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: "current-offer",
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }),
                            );
                        }
                    });
                }
                console.log('items:', items);
            } else {
                if (window.scs_show_bf_section) {
                    cc = window.scs_bonus_discount || "";
                    if (window.scs_bonus_product?.indexOf("getSeatId") !== -1) {
                        const obj2 = {
                            _gid: gid,
                            quantity: 1,
                            id: getSeatId(),
                            discount_code: cc,
                            properties: getProperties({
                                _source: `pdp_multi_step`,
                                _bonus_type: "GWPBonus",
                                _widget_id: "4100204",
                            }),
                        };
                        items.push(obj2);
                    } else {
                        if (window.scs_bonus_product) {
                            window.scs_bonus_product.split(",").map((id) => {
                                items.push(
                                    getItemObj(id, currentAppData, {
                                        _gid: gid,
                                        _bonus_type: "GWPBonus",
                                        _widget_id: "4100204",
                                    }),
                                );
                            });
                        }
                    }
                } else {
                    if (window.scs_show_earlybf_section) {
                        items.push(
                            getItemObj(49714091327780, currentAppData, {
                                _gid: gid,
                                _bonus_type: "GWPBonus",
                                _widget_id: "4100203",
                            }),
                        );
                        items.push(
                            getItemObj(49007184019748, currentAppData, {
                                _gid: gid,
                                _bonus_type: "GWPBonus",
                                _widget_id: "4100203",
                            }),
                        );
                        cc = "EARLYBFCM";
                    } else {
                        if (isBundle(currentAppData)) {
                            items.push(getItemObj(45340255387940, currentAppData));
                            items.push(getItemObj(49714091327780, currentAppData));
                            items.push(getItemObj(49007184019748, currentAppData));
                        } else if (isFront(currentAppData)) {
                            items.push(getItemObj(45340255387940, currentAppData));
                            items.push(getItemObj(49714091327780, currentAppData));
                        } else if (isRear(currentAppData)) {
                            items.push(getItemObj(45340255387940, currentAppData));
                        }
                    }
                }
            }

            if (currentAppData?.with_bonus) {
                const obj2 = {
                    quantity: 1,
                    id: getSeatId(),
                    discount_code: cc,
                    properties: getProperties({
                        _gid: gid,
                        _source: `pdp_multi_step`,
                    }),
                };
                items.push(obj2);
            }

            if (currentAppData?.addons === "Jump Seat Cover") {
                const obj1 = {
                    quantity: 1,
                    id: getJumpSeatCoverId(currentAppData.color),
                    properties: getProperties({
                        _source: `pdp_multi_step`,
                        _seat: currentAppData.seat,
                        _color: currentAppData.seat,
                        "Your Vehicle":
                            `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                        _your_vehicle:
                            `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                    }),
                };
                items.push(obj1);
            }

            var data = {
                items: items,
            };
            // loadingOverlay($(".cart-container form"), "show");

            if (window.is_embedded === true) {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append(
                    "X-Shopify-Storefront-Access-Token",
                    "2ec833273cdc3f57cd90d9b80c9c5a80",
                );

                const lines = data.items.map((item) => {
                    return {
                        merchandiseId: "gid://shopify/ProductVariant/" + item.id,
                        quantity: item.quantity,
                        attributes: item.properties
                            ? Object.keys(item.properties).map((key) => {
                                return {
                                    key: key,
                                    value: item.properties[key],
                                };
                            })
                            : [],
                    };
                });

                const graphql = JSON.stringify({
                    query:
                        "mutation cartCreate($input: CartInput) {\n  cartCreate(input: $input) {\n    cart {\n      # Cart fields\n      id\n      checkoutUrl\n    }\n    userErrors {\n      field\n      message\n    }\n   \n  }\n}",
                    variables: {
                        input: {
                            lines: lines,
                            metafields: [
                                {key: "cart_type", type: "string", value: "embedded"},
                            ],
                            note: "Date of Cart: " + new Date().toISOString(),
                        },
                    },
                });
                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: graphql,
                    redirect: "follow",
                };

                fetch(
                    "https://seatcoversolutions-7977.myshopify.com/api/2025-07/graphql.json",
                    requestOptions,
                )
                    .then((response) => response.json())
                    .then((result) => {
                        console.log(result);
                        window.location.href = result?.data?.cartCreate?.cart?.checkoutUrl;
                    })
                    .catch((error) => console.error(error));

                return;
            }

            console.log('add to cart:', data);

            // setDoubleOffer(); //TODO: remove this after testing
            // return;

            fetch("/cart/add.js", {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With":
                        "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                },
            })
                .then((response) => response.json())
                .then((resp) => {
                    // Do something with the resp
                    // console.log("updated");

                    if (
                        currentAppData?.with_bonus ||
                        window.scs_show_earlybf_section ||
                        window.scs_show_bf_section ||
                        window.scs_show_str_section ||
                        window.scs_show_new_year_promo_section
                    ) {
                        //fetch(`/discount/${cc}`)
                        fetch(`/checkout?discount=${cc}`)
                            .then(function () {
                                // After the discount code has been applied, force the cart to update so the discount is visible instantly
                                setTimeout(function () {
                                    fetch("/cart/update.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                            updates: {},
                                        }),
                                    }).then(function () {
                                        setLoading(false);
                                        setDoubleOffer();

                                    });
                                }, 500);
                            })
                            .catch(function (error) {
                                console.error("Error:", error);
                                setLoading(false);

                                setTimeout(function () {
                                    fetch("/cart/update.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                            updates: {},
                                        }),
                                    }).then(function () {
                                        setLoading(false);
                                        setDoubleOffer();
                                    });
                                }, 500);
                            });
                    } else {
                        setLoading(false);
                        setDoubleOffer();
                    }
                })
                .catch(function (error) {
                    // console.log("Request failed", error);
                    setLoading(false);
                });
        } else {
            if (currentAppData?.step === 1) {
                if (
                    !currentAppData.year ||
                    !currentAppData.make ||
                    !currentAppData.model
                ) {
                    alert(`Please select your vehicle`);
                    return;
                }
                setTimeout(function () {
                    setCurrentAppData((prevState) => {
                        return {
                            ...prevState,
                            step: prevState && prevState.step ? prevState.step + 1 : 1,
                            seat: "",
                        };
                    });
                    setTimeout(function () {
                        if (window.innerWidth < 768) {
                            const element = document.getElementById("step_2");
                            element?.scrollIntoView({
                                behavior: "smooth",
                            });
                        }
                    }, 50);
                }, 100);

                return;
            }

            setTimeout(function () {
                if (currentAppData?.step === 2) {
                    if (window.innerWidth < 768) {
                        const element = document.getElementById(`${styles.step_3}`);
                        element?.scrollIntoView({
                            behavior: "smooth",
                        });
                    }
                }
            }, 200);

            setCurrentAppData((prevState) => {
                return {
                    ...prevState,
                    step: prevState && prevState.step ? prevState.step + 1 : 1,
                };
            });
        }
    };

    let deps = [
        currentAppData?.check,
        currentAppData?.step,
        currentAppData?.make,
        currentAppData?.model,
        currentAppData?.year,
        currentAppData?.trim,
        currentAppData?.has_trims,
        currentAppData?.cab,
        currentAppData?.has_cabs,
        currentAppData?.seat,
        currentAppData?.color,
    ];

    // useWhatChanged(deps, 'check, step, make, mode, year, trim, has_trims, cab, has_cabs, seat, color');
    // @ts-ignore
    useEffect(() => {
        console.debug("StepNav: ", currentAppData);
        if (currentAppData?.step === 1) {
            let newStep = 1;
            if (currentAppData?.check) {
                if (
                    currentAppData?.year &&
                    currentAppData.make !== "" &&
                    currentAppData.model !== ""
                ) {
                    // console.log('d1');
                    // console.log('trim', currentAppData?.trim);
                    // console.log('has_trims', currentAppData?.has_trims);
                    if (currentAppData?.has_trims) {
                        let test_disabled =
                            currentAppData?.has_trims &&
                            (!currentAppData?.trim || currentAppData?.trim === "");
                        if (currentAppData?.has_cabs) {
                            test_disabled =
                                test_disabled ||
                                !currentAppData?.cab ||
                                currentAppData?.cab === "";
                            if (!test_disabled) {
                                newStep = 2;
                            }
                        }
                        if (!test_disabled) {
                            newStep = 2;
                        }

                        setDisabled(test_disabled || false);
                        // setCurrentAppData(prevState => {
                        //     return { ...prevState, step: newStep }
                        // });
                        console.log("test_disabled", test_disabled);
                    } else {
                        setDisabled(false);
                    }
                } else {
                    // console.log('d2');
                    setDisabled(true);
                }
            } else {
                // console.log('d3');
                setDisabled(true);
            }
        }
        if (currentAppData?.step === 2) {
            if (currentAppData.seat != undefined && currentAppData.seat != "") {
                // console.log('d4');
                setDisabled(false);
            } else {
                // console.log('d5');
                setDisabled(true);
            }
        }
        if (currentAppData?.step === 3) {
            if (currentAppData.color != "") {
                // console.log('d6');
                setDisabled(false);
            } else {
                // console.log('d7');
                setDisabled(true);
            }
        }
    }, deps);

    function getButtonText(comparePrice, price): JSX.Element {
        if (window.scs_custom_style == "style01") {
            if (currentAppData?.step == 1) {
                return <>Select Seat Options</>;
            }
            if (currentAppData?.step == 2) {
                return <>Select Color Options</>;
            }

            if (currentAppData?.step == 3) {
                return (
                    <>
                        Add To Cart - {comparePrice ? <s>{comparePrice}</s> : ""} {price}
                    </>
                );
            }
        } else {
            if (currentAppData?.step == 3) {
                return <>Add To Cart</>;
            }
        }

        return <>Next Step</>;
    }

    function getProperties(params: ScsProperties) {
        const newParams: CustomScsParams = {};
        if (window.sessionStorage.getItem("attribution")) {
            newParams._scs_attribution =
                window.sessionStorage.getItem("attribution") || "";
        }
        if (window.sessionStorage.getItem("utm_source")) {
            newParams._scs_utm_source =
                window.sessionStorage.getItem("utm_source") || "";
        }
        if (window.sessionStorage.getItem("utm_campaign")) {
            newParams._scs_utm_campaign =
                window.sessionStorage.getItem("utm_campaign") || "";
        }
        if (window.sessionStorage.getItem("utm_medium")) {
            newParams._scs_utm_medium =
                window.sessionStorage.getItem("utm_medium") || "";
        }
        if (currentAppData?.trim) {
            newParams._trim = currentAppData?.trim;
            //newParams.trim = currentAppData?.trim;
            newParams.Trim = `${currentAppData.trim}`;
        }
        if (currentAppData?.cab) {
            newParams._cab_size = currentAppData?.cab;
            //newParams.cab_size = currentAppData?.cab;
            newParams.Trim = `${currentAppData.trim} / ${currentAppData.cab}`;
        }

        try {
            const bodyClassList = document.body.classList;
            const accClass = Array.from(bodyClassList).find((c) =>
                c.startsWith("ACC_SCS_")
            );
            if (accClass) {
                newParams["_acc_template"] = accClass;
            }
        }
        catch (e) {
            console.error(e);
        }

        return {...params, ...newParams};
    }

    return (
        <>

            <section
                className={`${localStyles.section__step_nav} ${window.scs_custom_style ? styles.style01 : ""}`}
                id={`step_nav`}
            >
                {/*{currentAppData.step > 1 ?
                <button onClick={handleBack} className={`${localStyles.back}`}>Back</button> : ''}*/}
                <button
                    onClick={handleNext}
                    disabled={disabled || loading}
                    className={`${styles.btn} ${loading ? localStyles.loading : ""}`}
                >
                    {loading ? <span className={`${localStyles.loader}`}></span> : ""}
                    {currentAppData?.step && currentAppData?.step < 3 ? (
                        <span className={`${styles.btn_inner}`}>
              {getButtonText(comparePrice, price)}
                            <svg
                                width="10"
                                height="15"
                                viewBox="0 0 10 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                \n' + '
                <path
                    d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                    fill="white"
                />
                \n' + '
              </svg>
            </span>
                    ) : (
                        <span className={`${styles.btn_inner}`}>
              {getButtonText(comparePrice, price)}
                            <svg
                                width="10"
                                height="15"
                                viewBox="0 0 10 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                <path
                    d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                    fill="white"
                />
              </svg>
            </span>
                    )}
                </button>

                {partNumber ? (<div className={`${localStyles.section__step_info}`}>
                    Part #: {`${partNumber}`}
                </div>): ''}


            </section>
        </>
    );
}

function getJumpSeatCoverId(colorId) {
    const colorToJumpSeatCover = {
        Black: 49988033872164,
        Brown: 49988033904932,
        Grey: 49988033937700,
        Beige: 49988033970468,
        "Wine Red": 49988034003236,
    };

    return typeof colorToJumpSeatCover[colorId] !== "undefined"
        ? colorToJumpSeatCover[colorId]
        : colorToJumpSeatCover["Black"];
}

function getItemObj(id, currentAppData, defaultProps = {}): any {
    const newProps = {
        _seat: currentAppData.seat,
        _color: currentAppData.color,
        _bonus: "exclusive_sale",
    };
    try {
        const bodyClassList = document.body.classList;
        const accClass = Array.from(bodyClassList).find((c) =>
            c.startsWith("ACC_SCS_")
        );
        if (accClass) {
            newProps["_acc_template"] = accClass;
        }
    }
    catch (e) {
        console.error(e);
    }

    const objb1 = {
        quantity: 1,
        id: id,
        properties: {...newProps, ...defaultProps},
    };
    return objb1;
}
